import { Component, ViewChild, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageService } from '../../core/i18n/language.service';
import { MenuComponent } from '../menu/menu.component';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterLink, MenuComponent, FormsModule, TranslatePipe]
})
export class SidebarComponent {
  options = {
    lang: 'en',
    theme: 'winter',
    settings: false,
    docked: false,
    boxed: false,
    opened: false
  };

  @Output()
  messageEvent = new EventEmitter<Object>();
  @Output()
  toggleFullscreen = new EventEmitter<void>();
  @Output()
  menuClick = new EventEmitter<void>();

  // Language selection used to happen here, matching against /en|fr/ — a locale
  // this app does not ship. It now lives in LanguageService, which is the single
  // place that resolves the language and keeps <html lang>/<html dir> in sync.
  readonly language = inject(LanguageService);

  sendMessage() {
    this.messageEvent.emit(this.options);
  }

  setTheme(theme : any) {
    this.options.theme = theme;
    this.sendMessage();
  }
  
  /**
   * Handle menu item click event
   * Emit to parent component to close sidebar on mobile
   */
  onMenuItemClicked(): void {
    this.menuClick.emit();
  }
}
